module.exports = __webpack_public_path__ + "img/33.b596415a.jpg";